package team.platforma.dictionarydata.table

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AiModelQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: Long,
    name: String,
    chapter: Long,
    description: String,
    cover: String?,
  ) -> T): Query<T> = Query(177_748_703, arrayOf("AiModel"), driver, "AiModel.sq", "selectAll",
      "SELECT AiModel.id, AiModel.name, AiModel.chapter, AiModel.description, AiModel.cover FROM AiModel") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)
    )
  }

  public fun selectAll(): Query<AiModel> = selectAll { id, name, chapter, description, cover ->
    AiModel(
      id,
      name,
      chapter,
      description,
      cover
    )
  }

  public fun <T : Any> selectByChapter(chapter: Long, mapper: (
    id: Long,
    name: String,
    chapter: Long,
    description: String,
    cover: String?,
  ) -> T): Query<T> = SelectByChapterQuery(chapter) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)
    )
  }

  public fun selectByChapter(chapter: Long): Query<AiModel> = selectByChapter(chapter) { id, name,
      chapter_, description, cover ->
    AiModel(
      id,
      name,
      chapter_,
      description,
      cover
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun addAi(
    id: Long?,
    name: String,
    chapter: Long,
    description: String,
    cover: String?,
  ): Long {
    val result = driver.execute(-1_057_736_317, """
        |INSERT OR REPLACE INTO AiModel(id, name, chapter, description, cover)
        |VALUES (?, ?, ?, ?, ?)
        """.trimMargin(), 5) {
          bindLong(0, id)
          bindString(1, name)
          bindLong(2, chapter)
          bindString(3, description)
          bindString(4, cover)
        }.await()
    notifyQueries(-1_057_736_317) { emit ->
      emit("AiModel")
    }
    return result
  }

  private inner class SelectByChapterQuery<out T : Any>(
    public val chapter: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("AiModel", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("AiModel", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(258_613_940, """
    |SELECT AiModel.id, AiModel.name, AiModel.chapter, AiModel.description, AiModel.cover FROM AiModel
    |WHERE chapter = ?
    """.trimMargin(), mapper, 1) {
      bindLong(0, chapter)
    }

    override fun toString(): String = "AiModel.sq:selectByChapter"
  }
}
